import https from 'https';
import { apolloClient } from '../../apolloClient';
import { EXECUTE_INSTANCE_COMMAND } from '../../gql/executeInstanceCommand';

export function getRootApiLocation() {
  return '/api/sdpds';
}

export function httpCall(opts) {
  return new Promise((resolve) => {
    const req = https.request(opts, (res) => {
      res.setEncoding('utf8');
      let data = '';
      res.on('data', (chunk) => {
        data += chunk;
      });
      res.on('end', () => {
        const { statusCode, headers, body, error, message } = JSON.parse(data);
        resolve({ statusCode, headers, body: body || error || message });
      });
    });
    req.on('error', () => {
      const response = {
        statusCode: 401,
        body: {
          'Error ': 'Refresh Page to refresh midway cookies',
        },
      };
      resolve(response);
    });
    req.write(opts.body);
    req.end();
  });
}

export function apiCall(path, data) {
  const request = {
    path: `${getRootApiLocation()}${path}`,
    method: 'POST',
    json: true,
    headers: {
      'Content-Type': 'application/json',
      'kbn-xsrf': 'true',
    },
    body: JSON.stringify(data),
  };
  return httpCall(request);
}

export function convertEpochToDate(EpochTime) {
  EpochTime = parseInt(EpochTime);
  const digit = `${EpochTime}`.length;
  if (digit <= 10) {
    EpochTime = EpochTime * 1000;
  }
  const date = new Date(EpochTime);
  return date.toLocaleString('en-IN', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false,
    timeZoneName: 'short',
  });
}

export function getDefaultStack(config) {
  const stageMap = {
    beta: 'integ',
    gamma: 'staging',
    prod: 'prod',
  };
  const { region, stage } = config;

  //point to SDPDS Gamma for both PDX Beta and Gamma
  if (region === 'us-west-2' && stage === 'gamma') {
    return `swift-us-west-2-integ`;
  }
  return `swift-${region}-${stageMap[stage]}`;
}

/**
 * Backstop for a hung proxy; HttpLink has no request timeout of its own. The outermost bound in the chain,
 * so it sits above the Java proxy's 130s orchestrator and the ALB's 300s idle timeout and whichever of
 * those fires is what the operator is told about.
 */
export const TOOL_CALL_TIMEOUT_MS = 310 * 1000;

/**
 * Runs a tool via the BFF and returns the `executeCommand` payload ({ success, data, error }).
 *
 * Goes through the shared Apollo client rather than a hand-built POST because every tool reachable from here
 * is migrated, so piezoLink must see the operation to attach an artifact — and the document has to declare
 * $piezoArtifacts. `command` is any tool path, so only universally-accepted parameters are injected here;
 * tool-specific ones belong in the caller's `args`, since the proxy 400s on an undeclared parameter.
 */
export const executeNodeShellCommand = async (command, cluster, node, args) => {
  // Passed to fetch through HttpLink, so the request is cancelled rather than merely abandoned.
  const controller = new AbortController();
  const expiry = setTimeout(() => controller.abort(), TOOL_CALL_TIMEOUT_MS);
  try {
    const { data } = await apolloClient.mutate({
      mutation: EXECUTE_INSTANCE_COMMAND,
      variables: {
        url: command,
        args: {
          domain_identifier: cluster,
          ip_address: node,
          ...args,
        },
      },
      context: { fetchOptions: { signal: controller.signal } },
    });
    return data?.executeCommand;
  } finally {
    clearTimeout(expiry);
  }
};
